module.exports = __webpack_public_path__ + "assets/tagline_web_mobile_it.svg";


//////////////////
// WEBPACK FOOTER
// ../src/client/assets/taglines/tagline_web_mobile_it.svg
// module id = 442
// module chunks = 19